export default {
  password: "auth/set-password",
  notification: "auth/notification",
  checkStatusUpdate: "application/checkStatusUpdate",
  GOODSTANDING: (profileID) => `profile/good-standing/${profileID}`,
  notifications: "notifications",
};
